import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import { Toast, ToastContainer } from "react-bootstrap";

const ToastContext = createContext({ showToast: () => {} });

const VARIANT_BG = {
  success: "success",
  danger: "danger",
  warning: "warning",
  info: "primary",
};

export const useAppToast = () => useContext(ToastContext);

const AppToastProvider = ({ children }) => {
  const [items, setItems] = useState([]);

  const showToast = useCallback((message, variant = "info", title = "Aviso") => {
    const id = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
    setItems((prev) => [...prev, { id, title, message, variant }]);
  }, []);

  const removeToast = useCallback((id) => {
    setItems((prev) => prev.filter((t) => t.id !== id));
  }, []);

  const ctx = useMemo(() => ({ showToast }), [showToast]);

  return (
    <ToastContext.Provider value={ctx}>
      {children}
      <ToastContainer position="bottom-end" className="p-3" style={{ zIndex: 1080 }}>
        {items.map((item) => (
          <Toast
            key={item.id}
            onClose={() => removeToast(item.id)}
            autohide
            delay={3500}
            bg={VARIANT_BG[item.variant] || "primary"}
          >
            <Toast.Header closeButton>
              <strong className="me-auto">{item.title}</strong>
            </Toast.Header>
            <Toast.Body className="text-white">{item.message}</Toast.Body>
          </Toast>
        ))}
      </ToastContainer>
    </ToastContext.Provider>
  );
};

export default AppToastProvider;
